import { BaseTrack, TrackConfig, TrackData } from '../base/base-track';
import './logo-viewer';

const LOGO_HEIGHT = 80;

export class LogoTrack extends BaseTrack {
  constructor(config: TrackConfig, data: TrackData) {
    super('logo', { ...config, height: LOGO_HEIGHT }, data);
  }

  createHTML(): string {
    if (!this.hasRequiredData()) return '';

    return `
      <div style="display: flex; align-items: center;">
        <div style="width: ${this.config.labelWidth}px; flex-shrink: 0;">
          <div style="margin-bottom: 4px;">Sequence logo in bits</div>
        </div>
        <logo-viewer
          id="logo-track"
          style="display: block; flex: 1; overflow: hidden; min-width: 0;"
          display-start="${this.config.displayStart}"
          display-end="${this.config.displayEnd}"
          length="${this.config.sequenceLength}"
          height="${this.config.height}">
        </logo-viewer>
      </div>
    `;
  }

  setup(container: HTMLElement): void {
    this.element = container.querySelector('#logo-track') as HTMLElement;
    if (!this.element) {
      console.error('Logo track element not found');
      return;
    }
    (this.element as any).sequences = this.data.msaData.sequences;
  }

  update(config?: Partial<TrackConfig>, data?: Partial<TrackData>): void {
    if (config) this.config = { ...this.config, ...config };
    if (data) this.data = { ...this.data, ...data };
    if (this.element) {
      (this.element as any).sequences = this.data.msaData.sequences;
    }
  }

  destroy(): void {
    this.element = undefined;
  }
}
